<template>
  <ModalView
    v-model="visible"
    title="Notify applicant?"
    :subtitle="recipientEmail"
    :ok-title="renewal ? 'Renew license' : 'Save status'"
    cancel-title="Cancel"
    @ok="resolveAndClose(buildDecisions())"
    @cancel="resolveAndClose(null)"
  >
    <p class="mb-3">
      Choose which notifications to send with this {{ renewal ? 'renewal' : 'status change' }}.
    </p>
    <div class="d-flex flex-column gap-2">
      <label
        v-for="rule in rules"
        :key="rule.id"
        class="border rounded p-3 d-flex flex-row align-items-start gap-3"
      >
        <input
          v-model="selectedRuleIds"
          class="form-check-input mt-1"
          type="checkbox"
          :value="rule.id"
        />
        <span>
          <span class="d-block fw-semibold">{{ rule.name }}</span>
          <span class="d-block small text-muted">{{ rule.template?.subject }}</span>
        </span>
      </label>
    </div>
  </ModalView>
</template>

<script>
import ModalView from '@/components/common/ModalView.vue';

export default {
  components: { ModalView },
  data() {
    return {
      visible: false,
      renewal: false,
      recipientEmail: null,
      rules: [],
      selectedRuleIds: [],
      pendingResolve: null
    };
  },
  beforeUnmount() {
    this.resolve(null);
  },
  watch: {
    visible(value) {
      if (!value) this.resolve(null);
    }
  },
  methods: {
    guard({ recipientEmail, rules = [], renewal = false } = {}) {
      this.resolve(null);
      this.renewal = renewal;
      this.recipientEmail = recipientEmail || null;
      this.rules = rules;
      this.selectedRuleIds = rules.map(rule => rule.id);
      this.visible = true;
      return new Promise(resolve => {
        this.pendingResolve = resolve;
      });
    },
    buildDecisions() {
      const selected = new Set(this.selectedRuleIds);
      return Object.fromEntries(this.rules.map(rule => [
        rule.id,
        selected.has(rule.id) ? 'send' : 'skip'
      ]));
    },
    resolve(result) {
      const pendingResolve = this.pendingResolve;
      this.pendingResolve = null;
      if (pendingResolve) pendingResolve(result);
    },
    resolveAndClose(result) {
      this.resolve(result);
      this.visible = false;
    }
  }
};
</script>
